"use client";

import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { CreateConnectorFn } from "wagmi";
import currentChain, { currentL1Chain } from "lib/web3/currentChain";
import { hoodi, mainnet } from "viem/chains";
import appConfig from "configs/app";
import wagmi from "lib/web3/wagmiConfig";

import { safe } from "wagmi/connectors";
import { type AppKitNetwork } from "@reown/appkit/networks";

// Get projectId from https://cloud.walletconnect.com
const feature = appConfig.features.blockchainInteraction;
export const projectId = feature.isEnabled
  ? feature.walletConnect.projectId
  : "";

if (feature.isEnabled && !projectId) {
  throw new Error("Project ID is not defined");
}

export const metadata = {
  name: process.env.MORPH_WEBSITE_NAME || "Morph Explorer",
  description:
    process.env.MORPH_WEBSITE_DESCRIPTION ||
    "Upgrade your blockchain experience with Morph - the secure, decentralized, cost-efficient, and high-performing EVM-equivalent rollup. Try it now!",
  url: process.env.MORPH_WEBSITE_URL || "https://explorer.morph.network",
  icons: [
    process.env.MORPH_WEBSITE_ICON ||
      "https://morph.network/logo/morph-256*256.png",
  ],
};

// Create wagmiConfig [1].includes(Number(val.id)) ||
export const chains = [currentChain, currentL1Chain];
// console.log('currentL1Chain', currentL1Chain);
// if (currentL1Chain.name) {
//   chains.push(currentL1Chain)
// }

let connectors: CreateConnectorFn[] = [
  safe({
    allowedDomains: [
      /^app\.safe\.global$/,
      /^safe\.global$/,
      /^safe\.morph\.network$/,
      /^safe\.morphl2\.io$/,
      /.*\.morphl2\.io$/,
      /^localhost:3002$/,
      /^localhost:2818$/,
    ],
    debug: false,
    // shimDisconnect: false,
  }),
];

if (projectId) {
  // A WalletConnect ID is provided so we add the Connector for testing purposes
  connectors = [...connectors];
}

export const networks = [chains[0]] as [AppKitNetwork, ...AppKitNetwork[]];

export const wagmiAdapter = feature.isEnabled
  ? new WagmiAdapter({
      projectId,
      ssr: true,
      connectors,
      networks: networks as any,
    })
  : null;

export const config =
  feature.isEnabled && wagmiAdapter ? wagmiAdapter.wagmiConfig : wagmi.config;
